import * as React from "react";
import { IconProps } from "./IconProps";

export const IconMinimize = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="minimize, arrow, shrink">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9711 2.02859C14.2314 2.28894 14.2314 2.71105 13.9711 2.9714L10.9425 6H13.333C13.7012 6 13.9997 6.29848 13.9997 6.66667C13.9997 7.03486 13.7012 7.33333 13.333 7.33333H9.33301C8.96482 7.33333 8.66634 7.03486 8.66634 6.66667V2.66667C8.66634 2.29848 8.96482 2 9.33301 2C9.7012 2 9.99967 2.29848 9.99967 2.66667V5.05719L13.0283 2.02859C13.2886 1.76824 13.7107 1.76824 13.9711 2.02859ZM1.99967 9.33333C1.99967 8.96514 2.29815 8.66667 2.66634 8.66667H6.66634C7.03453 8.66667 7.33301 8.96514 7.33301 9.33333V13.3333C7.33301 13.7015 7.03453 14 6.66634 14C6.29815 14 5.99967 13.7015 5.99967 13.3333V10.9428L2.97108 13.9714C2.71073 14.2318 2.28862 14.2318 2.02827 13.9714C1.76792 13.7111 1.76792 13.2889 2.02827 13.0286L5.05687 10H2.66634C2.29815 10 1.99967 9.70152 1.99967 9.33333Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
